import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertHtmlTag, convertTagStyle, convertLineStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './GoodsAfterSaleDetail.less';

export default class GoodsAfterSaleDetail extends OfficialPage {
  state = {
    orderReason: [
      '商家待审核',
      '商家拒绝退款',
      '买家撤销退款',
      '待买家退货',
      '待商家确认收货',
      '卖家超时未退货',
      '已退款',
      '商家超时未处理退款'
    ],
    refundReason: [
      '多拍/拍错/不想要',
      '快递延期',
      '未按约定时间发货',
      '快递记录出错',
      '内容与描述不符',
      '其它'
    ],
    refundJourneyReason: [
      '未保持餐品完整',
      '骑手服务态度恶劣',
      '骑手额外索取费用',
      '骑手诱导退单',
      '骑手提前点击送达',
      '骑手虚假标记异常',
      '少餐错餐'
    ],
    orderIcon: [
      'goods-undone-payment',
      'goods-refund-doing',
      'goods-refund-doing',
      'goods-refund',
      'goods-undone-receipt',
      'goods-refund-doing',
      'goods-already-refund',
      'goods-refund-doing'
    ],
    orderId: '',
    showEventDialog: false,
    eventType: '',
    storeStyle: {}
  }
  isFromBack = false
  applyId = ''
  
  constructor(props) {
    super(props);
    document.title = '售后详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.applyId = options.applyId
    this.franchiseeId = options.franchisee || ''
    this.setData({
      orderId: options.detail
    })
    this.dataInitial()
  }

  componentDidMount() {
    if (this.isFromBack) {
      this.getAfterSaleOrder()
    } else {
      this.isFromBack = true
    }
  }

  dataInitial = () => {
    this.getAfterSaleOrder()
    this.getAppECStoreConfig()
  }
  getAfterSaleOrder = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appShop/getAfterSaleOrder',
      data: {
        apply_id: _this.applyId,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        _this.setData({
          afterSaleData: res.data
        })
        _this.getRefundConfigByPickUpType()
        if (res.data.pick_up_type == 2) {
          _this.getBuyerCancelReason()
        }
      }
    })
  }
  orderDelete = e => {
    let orderId = this.data.orderId
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteAfterSaleOrderLog',
      method: 'post',
      data: {
        order_id: orderId,
        apply_id: _this.applyId
      },
      success: function (res) {
        app.turnBack()
      },
      complete: function () {
        _this.setData({
          showEventDialog: false
        })
      }
    })
  }
  editorRefund = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsRefundPage/goodsRefundPage?type=editor&orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  checkLogistics = () => {
    let applyId = this.applyId
    let franchiseeId = this.franchiseeId
    app.turnToPage(
      '/eCommerce/pages/logisticsPage/logisticsPage?applyId=' +
      applyId +
      '&form=afterSale' +
      (franchiseeId ? '&franchiseeId=' + franchiseeId : '')
    )
  }
  copyOrderId = () => {
    let _this = this
    app.setClipboardData({
      data: _this.data.orderId,
      success: function (res) {
        app.showToast({
          title: '复制成功',
          icon: 'success'
        })
      }
    })
  }
  hideEventDialog = () => {
    this.setData({
      showEventDialog: false
    })
  }
  showEventDialog = event => {
    this.setData({
      eventType: event.currentTarget.dataset.type,
      showEventDialog: true
    })
  }
  goOrderProgress = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsOrderProgress/goodsOrderProgress?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  returnInfor = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsReturnInfor/goodsReturnInfor?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.franchiseeId)
  }
  cancelRefund = () => {
    let _this = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    app.sendRequest({
      url: '/index.php?r=appShop/cancelRefund',
      data: {
        order_id: orderId,
        sub_shop_app_id: franchiseeId
      },
      success: function () {
        _this.getAfterSaleOrder()
      },
      complete: function () {
        _this.setData({
          showEventDialog: false
        })
      }
    })
  }
  getRefundConfigByPickUpType = () => {
    let _this = this
    let type = this.data.afterSaleData.pick_up_type
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getRefundConfigByPickUpType',
      data: {
        pick_up_type: type,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        let data = res.data.config_data
        _this.setData({
          refundAdress: data.address || ''
        })
      }
    })
  }
  getBuyerCancelReason = () => {
    let type = this.data.afterSaleData.deliver_type || 0
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getBuyerCancelReason',
      data: {
        deliver_type: type
      },
      success: function (res) {
        let data = res.data
        let refundJourneyReason = []
        for (let i in data) {
          refundJourneyReason.push(data[i])
        }
        _this.setData({
          refundJourneyReason: refundJourneyReason
        })
      }
    })
  }

  render() {
    let {
      showGetUserInfo,
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      storeStyle,
      orderIcon,
      afterSaleData,
      orderReason,
      refundAdress,
      refundJourneyReason,
      refundReason,
      eventType,
      showEventDialog
    } = this.state
   
    afterSaleData = afterSaleData || {};
    return (
      <div className="official-page goods-after-sale-detail">
        <TopNav title="售后详情" />
        <div className="order-contain">
          <div
            className="seller-shipped"
            style={convertLineStyleData('background:' + storeStyle.theme)}
          >
            <span
              className={
                'order-icon ico-moon icon-' + orderIcon[afterSaleData.status]
              }
            ></span>
            <span>{orderReason[afterSaleData.status]}</span>
            <img src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-goods/goods-order-bg.png" />
          </div>
          {afterSaleData.status == 0 && (
            <div className="order-prompt">
              你已成功发起退款申请，请耐心等待商家处理，还剩
              <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                {afterSaleData.expire}
              </span>
              （超时按<span style={convertLineStyleData('color:' + storeStyle.theme)}>拒绝退款</span>
              处理）
            </div>
          )}
          {afterSaleData.status == 3 && (
            <div className="order-prompt">
              商家已同意你的退货申请，请及时填写退货信息，还剩
              <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                {afterSaleData.expire}
              </span>
              （超时按<span style={convertLineStyleData('color:' + storeStyle.theme)}>退款失败</span>
              处理）
            </div>
          )}
          {afterSaleData.status == 3 && (
            <React.Fragment>
              <div className="refund-address-box">
                <div className="refund-address-title">
                  <span>退货地址</span>
                  <span className="pull-right">
                    {refundAdress && refundAdress.brand_name + ' ' + refundAdress.phone}
                  </span>
                </div>
                <div className="pull-right refund-address">
                  {refundAdress && refundAdress.region_info[2].name +
                    refundAdress.region_info[1].name +
                    refundAdress.region_info[0].name +
                    refundAdress.detail_address}
                </div>
              </div>
            </React.Fragment>
          )}
          {afterSaleData.refuse_msg && (
            <div className="refuse-message">
              {'商家拒绝退款原因：' + afterSaleData.refuse_msg}
            </div>
          )}
          <div className="app-box">
            <div>
              <span className="app-name">退货信息</span>
            </div>
          </div>
          {afterSaleData.refund_goods && afterSaleData.refund_goods.map((item, index) => {
            return (
              <div className="goods-detail-box" key={item.goods_id}>
                <img src={item.cover} />
                <div>
                  <div className="goods-name">
                    {afterSaleData.is_group_buy_order == 1 && (
                      <span className="is-seckill">拼团</span>
                    )}
                    {afterSaleData.is_seckill == 1 && (
                      <span className="is-seckill">秒杀</span>
                    )}
                    {item.title}
                  </div>
                  {item.model_name && (
                    <div className="goods-rules">{item.model_name}</div>
                  )}
                  <div className="goods-price">
                    <span
                      className="colorff7"
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                    >
                      {'¥' + item.price}
                    </span>
                    <span className="pull-right">{'x ' + item.num}</span>
                  </div>
                </div>
              </div>
            )
          })}
          <div
            className="goods-amount"
            hidden={afterSaleData.is_pay_on_delivery == 1}
          >
            <span>退货原因</span>
            <span className="pull-right color999">
              {afterSaleData.pick_up_type == 2
                ? refundJourneyReason[afterSaleData.refund_reason]
                : refundReason[afterSaleData.refund_reason]}
            </span>
          </div>
          <div className="goods-amount">
            <span>退款金额</span>
            <span className="pull-right color999">
              {'¥' + afterSaleData.refund_price}
            </span>
          </div>
          <div className="goods-amount refund-apply-time">
            <span>申请时间</span>
            <span className="pull-right color999">
              {afterSaleData.add_time}
            </span>
          </div>
          <div className="actual-payment">
            <div>
              <span>实际付款</span>
              <span
                className="pull-right colorff7"
                style={convertLineStyleData('color:' + storeStyle.theme)}
              >
                {'¥' + afterSaleData.total_price}
              </span>
            </div>
          </div>
          <div
            className="addition-info no-border"
            onClick={this.goOrderProgress}
          >
            <div>
              <span>订单进度</span>
              <span className="pull-right color999 ico-moon icon-rightarrow"></span>
            </div>
          </div>
          <div className="order-number">
            <div>
              <span>订单编号</span>
              <span>{afterSaleData.order_id}</span>
              <span className="pull-right" onClick={this.copyOrderId}>
                复制
              </span>
            </div>
          </div>
          <div className="order-bottom">
            {afterSaleData.status == 0 && (
              <React.Fragment>
                <span
                  className="btn"
                  onClick={this.showEventDialog}
                  data-type="cancelRefund"
                >
                  撤销申请
                </span>
                {afterSaleData.is_pay_on_delivery != 1 && (
                  <span className="btn" onClick={this.editorRefund}>
                    修改申请
                  </span>
                )}
              </React.Fragment>
            )}
            {afterSaleData.status == 1 && (
              <React.Fragment>
                <span
                  className="btn"
                  onClick={this.showEventDialog}
                  data-type="orderDelete"
                >
                  删除售后订单
                </span>
              </React.Fragment>
            )}
            {afterSaleData.status == 2 && (
              <React.Fragment>
                <span
                  className="btn"
                  onClick={this.showEventDialog}
                  data-type="orderDelete"
                >
                  删除售后订单
                </span>
              </React.Fragment>
            )}
            {afterSaleData.status == 3 && (
              <React.Fragment>
                <span
                  className="btn"
                  onClick={this.showEventDialog}
                  data-type="cancelRefund"
                >
                  撤销申请
                </span>
                {afterSaleData.is_pay_on_delivery != 1 && (
                  <span className="btn" onClick={this.editorRefund}>
                    修改申请
                  </span>
                )}
                {afterSaleData.is_pay_on_delivery != 1 && (
                  <span
                    className="btn btn-orange"
                    style={convertLineStyleData(
                      'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme
                    )}
                    onClick={this.returnInfor}
                  >
                    填写退货信息
                  </span>
                )}
              </React.Fragment>
            )}
            {afterSaleData.status == 4 && (
              <React.Fragment>
                <span className="btn" onClick={this.checkLogistics}>
                  查看退货物流
                </span>
              </React.Fragment>
            )}
            {afterSaleData.status == 5 && (
              <React.Fragment>
                <span
                  className="apply-refund"
                  onClick={this.showEventDialog}
                  data-type="orderDelete"
                >
                  删除售后订单
                </span>
              </React.Fragment>
            )}
            {afterSaleData.status == 6 && (
              <React.Fragment>
                <span
                  className="apply-refund"
                  onClick={this.showEventDialog}
                  data-type="orderDelete"
                >
                  删除售后订单
                </span>
              </React.Fragment>
            )}
            {afterSaleData.status == 7 && (
              <React.Fragment>
                <span
                  className="apply-refund"
                  onClick={this.showEventDialog}
                  data-type="orderDelete"
                >
                  删除售后订单
                </span>
              </React.Fragment>
            )}
          </div>
        </div>
        {showEventDialog && (
          <div className="event-dialog-mask">
            <div className="event-dialog">
              {eventType == 'orderDelete' && (
                <div className="event-dialog-title">
                  订单删除后不可找回，确认删除？
                </div>
              )}
              {eventType == 'cancelRefund' && (
                <div className="event-dialog-title">是否撤销退款申请？</div>
              )}
              <div className="event-dialog-bottom">
                <span className="event-cancel" onClick={this.hideEventDialog}>
                  取消
                </span>
                {eventType == 'orderDelete' && (
                  <span
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                    className="event-sure"
                    onClick={this.orderDelete}
                  >
                    确认
                  </span>
                )}
                {eventType == 'cancelRefund' && (
                  <span
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                    className="event-sure"
                    onClick={this.cancelRefund}
                  >
                    确认
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-after-sale-detail/GoodsAfterSaleDetail.jsx